import { JetpacCatalogApi, JetpacRewardApi } from 'api'

class RewardsAPI {
  static getAllPromocodesForOneUser({ userId, faberToken }: PromocodeProps) {
    return JetpacRewardApi.httpGet(
      `reward/ops/wallet/promocode/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data
    })
  }

  static getPromocodeUsers({ promocode, faberToken } : PromocodeUsersProps) {
    return JetpacRewardApi.httpGet(
      `reward/ops/promocode/${promocode}/user`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data
    })
  }

  static getCampaignPromocodes(
    code,
    limit,
    offset,
    sort,
    faberToken: PromocodeProps
  ) {
    return JetpacRewardApi.httpGet(
      `/reward/ops/promocode/campaign?code=${code}&limit=${limit}&offset=${offset}&orderBy=${sort}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data
    })
  }

  static updateCampaignPromo({id, faberToken, ...body}: UpdateCampaignPromoBody) {
    return JetpacRewardApi.httpPut(
      `/reward/ops/promocode/campaign/${id}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    ).then((res) => {
      return res.data
    })
  }

  static getDistributorPromocodes(
    code,
    limit,
    offset,
    sort,
    faberToken: PromocodeProps
  ) {
    return JetpacRewardApi.httpGet(
      `/reward/ops/promocode/distributor?code=${code}&limit=${limit}&offset=${offset}&orderBy=${sort}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data
    })
  }

  static updateDistributorPromocode({id, faberToken, ...body}: UpdateCampaignPromoBody) {
    return JetpacRewardApi.httpPut(
      `/reward/ops/promocode/distributor/${id}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    ).then((res) => {
      return res.data
    })
  }

  static getReferralPromocodes(
    code,
    limit,
    offset,
    sort,
    faberToken: PromocodeProps
  ) {
    return JetpacRewardApi.httpGet(
      `/reward/ops/promocode/referral?code=${code}&limit=${limit}&offset=${offset}&orderBy=${sort}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data
    })
  }

  static createPromoCode(body: PromoCodeModel) {
    return JetpacRewardApi.httpPost(
      `/reward/ops/promocode`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static getRewardProducts(faberToken: string) {
    return JetpacRewardApi.httpGet(
      `/reward/ops/product`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data.data
    })
  }

  static createRewardProduct(body: RewardProductModel) {
    return JetpacRewardApi.httpPost(
      `/reward/ops/product/create`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static getBenefits(faberToken: string) {
    return JetpacRewardApi.httpGet(
      `/reward/ops/benefit`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data.data
    })
  }

  static createBenefit(body: BenefitModel) {
    return JetpacRewardApi.httpPost(
      `/reward/ops/benefit/create`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

static getCatalogs(faberToken: string, onlyShowBase?: boolean) {
  let url = '/catalog/ops/item?showClient=true';
  if (onlyShowBase === true) {
    url += '&packageType=BASE'
  }

  return JetpacCatalogApi.httpGet(url, {
      Authorization: `Bearer ${faberToken}`
    }, true)
    .then((res) => {
      return res.data.body.data;
    })
}

  static createDistributor(body: DistributorModel) {
    return JetpacRewardApi.httpPost(
      `/reward/ops/distributor`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static getDistributors(faberToken: string) {
    return JetpacRewardApi.httpGet(
      `/reward/ops/distributor`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data.data
    })
  }

  static createDistributorPromo(body: DistributorPromoModel) {
      return JetpacRewardApi.httpPost(
      `/reward/ops/promocode/distributor`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static getRewardRules(faberToken: string) {
    return JetpacRewardApi.httpGet(
      `/reward/ops/rule`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data.data
    })
  }

  static createRewardRule(body: CreateRewadRule) {
    return JetpacRewardApi.httpPost(
      `/reward/ops/promocode/rule`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      [body]
    )
  }

  static generateDistributorTrialCodes(faberToken: string) {
    return JetpacRewardApi.httpPost(
      `/reward/ops/promocode/distributor/generate`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => {
      return res.data.data
    })
  }
}

export default RewardsAPI

interface PromocodeProps {
  userId: string
  faberToken: string
  code?: string
  limit?: number
  offset?: number
  sort?: string
}

interface PromocodeUsersProps {
  promocode: string,
  faberToken: string
}

interface PromoCodeModel {
  campaignRewardName: string
  campaignSummary: string
  campaignCode: string
  campaignCodePrefix?: string
  rewardProductId: string
  maxClaims: number
  maxConsumption: number
  validityStartAt: number
  validityEndAt: number
  promoRule: string[]
  faberToken: string
}

interface RewardProductModel {
  rewardName: string
  rewardDescription: string
  rewardDescriptionInternal: string
  benefitTypeId: string[]
  rewardRuleId: string[]
  faberToken: string
}

interface BenefitModel {
  benefitSummary: string
  benefitCategory: string
  benefitProductID?: string
  benefitValue: string
  benefitUnit: string
  faberToken: string
}

interface DistributorModel {
  distributorName: string
  faberToken: string
}

interface DistributorPromoModel {
  distributorId: string
  promocodeSummary: string
  rewardProductId: string
  maxClaims: number
  maxConsumption: number
  validityStartAt: number
  validityEndAt: number
  batchSize: number
  promoRule: string[]
  faberToken: string
}

interface UpdateCampaignPromoBody {
  id: string;
  faberToken: string;
  maxConsumption: number;
  validityEndAt?: number;
  promoRule: string[];
}

interface CreateRewadRule{
  ruleName: string;
  ruleDescription: string;
  ruleType: string;
  ruleValue: string;
  faberToken: string;
}
